import { Component, ChangeDetectionStrategy } from '@angular/core'
import { MatTooltip } from '@angular/material/tooltip'
import { MatIconButton } from '@angular/material/button'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'lib-contact-golab',
  templateUrl: './contact-golab.component.html',
  styleUrls: ['./contact-golab.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, MatTooltip, MatIconButton],
})
export class ContactGolabComponent {
  contactGolab() {
    window.open('mailto:go-lab@utwente.nl', '_blank')
  }
}
